import { ApiClient, ApiError, ApiErrorCode } from '@bustickus/api';
import { IClientTicketBrief, IClientTicketDownloadBrief, IClientTicketFull } from '@bustickus/models-client';
import { createApiAddress } from 'common/helpers';
import { AuthService } from 'common/services';

class ApiTickets {
  private readonly client: ApiClient = ApiClient.getInstance();
  private static instance: ApiTickets | null = null;

  private constructor() {}

  static getInstance(): ApiTickets {
    if (ApiTickets.instance == null) {
      ApiTickets.instance = new ApiTickets();
    }

    return ApiTickets.instance;
  }

  async get(ticketId: string): Promise<IClientTicketFull> {
    const jwt = this.jwt();
    const address = createApiAddress(`/client/tickets/${ticketId}`);
    const ticket = await this.client.sendRequest<IClientTicketFull>('get', address, null, jwt);
    return ticket;
  }

  async getAll(): Promise<IClientTicketBrief[]> {
    const jwt = this.jwt();
    const address = createApiAddress('/client/tickets');
    const tickets = await this.client.sendRequest<IClientTicketBrief[]>('get', address, null, jwt);
    return tickets;
  }

  async getPdfTocket(ticketId: string): Promise<IClientTicketDownloadBrief> {
    const jwt = this.jwt();
    const address = createApiAddress(`/client/tickets/${ticketId}/pdf/token`);
    const response = await this.client.sendRequest<IClientTicketDownloadBrief>('get', address, null, jwt);
    return response;
  }

  getPdfLink(ticketId: string, token: string): string {
    return createApiAddress(`/client/tickets/${ticketId}/pdf?token=${token}`);
  }

  async createRefund(ticketId: string, reason: string) {
    const jwt = this.jwt();
    const address = createApiAddress(`/client/tickets/${ticketId}/refund`);
    const request = {
      reason: reason.trim(),
    };

    await this.client.sendRequest('post', address, request, jwt);
  }

  private jwt() {
    const authService = AuthService.getInstance();
    const jwt = authService.get();

    if (jwt == null) {
      throw new ApiError(ApiErrorCode.Unauthorized);
    }

    return jwt;
  }
}

export default ApiTickets;
